import { useQuery } from '@tanstack/react-query';
import { getClinics } from '../../../../apis/clinics/requests';
import { usePersistedTotal } from '../../../../hooks/useTablePagination';

export const useClinics = (page: number, limit: number) => {
  const { data: clinicsResponse, isFetched: isLoaded } = useQuery({
    queryKey: ['clinics', page, limit],
    queryFn: () => getClinics(page, limit),
    meta: { errorMessage: 'Failed to load clinics list' },
  });

  const total = usePersistedTotal(clinicsResponse?.pagination?.total);

  return {
    clinics: clinicsResponse?.data || [],
    isLoaded,
    total
  };
};
